import React from 'react';
import {Image} from '@/components-v2';
import {getImageUrl} from '@/utils';
import {GoldAreaItem} from '../home.type';

const activeStyle = {
  color: '#E91100',
  background:
    'linear-gradient(180deg, #FFB9B9 0%, rgba(255, 221, 221, 0) 100%)',
  borderTopColor: '#E91100',
};

const baseItemStyle = {
  borderTop: '2px solid transparent',
  transition: 'all 0.3s linear',
};

interface AnnaGoldAreaProps {
  activeIndex: number;
  list: GoldAreaItem[];
  onChange: (index: number) => void;
}

const AnnaGoldArea = ({
  activeIndex = 0,
  list = [],
  onChange,
}: AnnaGoldAreaProps) => {
  if (list.length === 0) {
    return null;
  }

  return (
    <div className="bg-light-grey flex gap-2 overflow-x-auto px-3">
      {list.map((item, index) => {
        const isActive = index === activeIndex;
        const title = item.moduleName || item.moduleType;
        const imageUrl = getImageUrl(item.bgImgUrl || item.defaultImgUrl || '');

        return (
          <div
            key={index}
            onClick={() => onChange(index)}
            className={`home-gold-item flex w-[3.75rem] flex-none cursor-pointer flex-col items-center overflow-hidden pb-2 pt-0.5 ${
              isActive ? 'active px-2' : ''
            }`}
            style={
              isActive ? {...baseItemStyle, ...activeStyle} : baseItemStyle
            }>
            <div className="h-[3rem] w-[3rem]">
              {imageUrl ? (
                <Image
                  src={imageUrl}
                  alt={title}
                  fit="contain"
                  className="h-[3rem] w-[3rem]"
                />
              ) : null}
            </div>
            <p className="text-xs">{title}</p>
          </div>
        );
      })}
    </div>
  );
};

export default AnnaGoldArea;
